var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("h2", { staticStyle: { "margin-top": "0" } }, [
        _vm._v(_vm._s(_vm.$t("diagnostics.title"))),
      ]),
      _c("p", { staticStyle: { color: "#909399", "margin-top": "-8px" } }, [
        _vm._v(
          " " +
            _vm._s(_vm.$t("diagnostics.introSnapshots")) +
            " " +
            _vm._s(_vm.$t("diagnostics.introUsage")) +
            " "
        ),
      ]),
      _c(
        "div",
        { staticStyle: { "margin-bottom": "14px" } },
        [
          _c("el-input", {
            staticStyle: { width: "280px" },
            attrs: {
              placeholder: _vm.$t("diagnostics.serialPlaceholder"),
              clearable: "",
            },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.onSearch.apply(null, arguments)
              },
            },
            model: {
              value: _vm.filter.serial,
              callback: function ($$v) {
                _vm.$set(_vm.filter, "serial", $$v)
              },
              expression: "filter.serial",
            },
          }),
          _c(
            "el-select",
            {
              staticStyle: { width: "170px", "margin-left": "8px" },
              attrs: {
                placeholder: _vm.$t("diagnostics.source"),
                clearable: "",
              },
              model: {
                value: _vm.filter.source,
                callback: function ($$v) {
                  _vm.$set(_vm.filter, "source", $$v)
                },
                expression: "filter.source",
              },
            },
            [
              _c("el-option", {
                attrs: {
                  label: _vm.$t("diagnostics.sourceMobileApp"),
                  value: "mobile_app",
                },
              }),
              _c("el-option", {
                attrs: {
                  label: _vm.$t("diagnostics.sourceProductionPlatform"),
                  value: "production_platform",
                },
              }),
            ],
            1
          ),
          _c("el-date-picker", {
            staticStyle: { "margin-left": "8px" },
            attrs: {
              type: "daterange",
              "range-separator": "-",
              "start-placeholder": _vm.$t("diagnostics.startDate"),
              "end-placeholder": _vm.$t("diagnostics.endDate"),
              "value-format": "yyyy-MM-dd",
            },
            model: {
              value: _vm.filter.dateRange,
              callback: function ($$v) {
                _vm.$set(_vm.filter, "dateRange", $$v)
              },
              expression: "filter.dateRange",
            },
          }),
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "8px" },
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.onSearch },
            },
            [_vm._v(_vm._s(_vm.$t("diagnostics.search")))]
          ),
          _c(
            "el-button",
            {
              attrs: { icon: "el-icon-refresh" },
              on: { click: _vm.resetFilter },
            },
            [_vm._v(_vm._s(_vm.$t("diagnostics.reset")))]
          ),
          _c(
            "el-checkbox",
            {
              staticStyle: { "margin-left": "12px" },
              attrs: { disabled: !!_vm.filter.serial.trim() },
              on: { change: _vm.onSearch },
              model: {
                value: _vm.filter.groupByCane,
                callback: function ($$v) {
                  _vm.$set(_vm.filter, "groupByCane", $$v)
                },
                expression: "filter.groupByCane",
              },
            },
            [_vm._v(_vm._s(_vm.$t("diagnostics.groupByCane")))]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: {
            "margin-bottom": "8px",
            color: "#909399",
            "font-size": "13px",
          },
        },
        [
          _vm.filter.serial
            ? _c("span", [
                _vm._v(_vm._s(_vm.$t("diagnostics.deviceLabel")) + " "),
                _c("b", [_vm._v(_vm._s(_vm.filter.serial))]),
                _vm._v(" - "),
              ])
            : _vm._e(),
          _vm._v(" " + _vm._s(_vm.$t("diagnostics.total")) + " "),
          _c("b", [_vm._v(_vm._s(_vm.total))]),
          _vm._v(
            " " +
              _vm._s(
                _vm.isGrouped
                  ? _vm.$tc("diagnostics.caneUnit", _vm.total)
                  : _vm.$tc("diagnostics.snapshotUnit", _vm.total)
              ) +
              " "
          ),
          _vm.isGrouped
            ? _c("span", [
                _vm._v(" " + _vm._s(_vm.$t("diagnostics.latestPerCane"))),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: { data: _vm.list, border: "", stripe: "", size: "small" },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("diagnostics.received"),
              prop: "receivedAt",
              width: "160",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(_vm._s(_vm.fmtTime(row.receivedAt)))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("diagnostics.serialNo"),
              prop: "caneSerialNumber",
              "min-width": "170",
            },
          }),
          _vm.isGrouped
            ? _c("el-table-column", {
                attrs: { label: "Snapshot", width: "100", align: "center" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "el-tag",
                            { attrs: { size: "mini", type: "info" } },
                            [_vm._v(_vm._s(row.snapshotCount))]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  75805243
                ),
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("diagnostics.source"),
              width: "110",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type:
                            row.source === "production_platform"
                              ? "warning"
                              : "success",
                          size: "mini",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              row.source === "production_platform"
                                ? _vm.$t("diagnostics.production")
                                : _vm.$t("diagnostics.mobile")
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Firmware",
              prop: "firmwareVersion",
              width: "100",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("diagnostics.battery"),
              width: "110",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm.bat(row)
                      ? _c("span", [
                          _vm._v(
                            _vm._s(_vm.bat(row).charge) +
                              "% / " +
                              _vm._s(_vm.bat(row).voltageMv) +
                              "mV"
                          ),
                        ])
                      : _c("span", [_vm._v("-")]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("diagnostics.health"),
              width: "80",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm.bat(row)
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.bat(row).healthPercent) + "%"),
                        ])
                      : _c("span", [_vm._v("-")]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Uptime", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(_vm._s(_vm.uptime(row)))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Fault", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm.faultCount(row) === 0
                      ? _c(
                          "el-tag",
                          { attrs: { type: "success", size: "mini" } },
                          [_vm._v(_vm._s(_vm.$t("diagnostics.clean")))]
                        )
                      : _c(
                          "el-tag",
                          { attrs: { type: "danger", size: "mini" } },
                          [_vm._v(_vm._s(_vm.faultCount(row)) + " fault")]
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("diagnostics.unregistered"),
              width: "110",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    !row.deviceId
                      ? _c(
                          "el-tag",
                          { attrs: { type: "info", size: "mini" } },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("diagnostics.unregisteredDevice"))
                            ),
                          ]
                        )
                      : _c("span", [_vm._v("-")]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "", width: "180", align: "center", fixed: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm.isGrouped
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.viewCaneSnapshots(row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("diagnostics.snapshots")))]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "info" },
                        on: {
                          click: function ($event) {
                            return _vm.openDetail(row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("diagnostics.details")))]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        staticStyle: { "margin-top": "14px", "text-align": "right" },
        attrs: {
          background: "",
          layout: "total, sizes, prev, pager, next",
          total: _vm.total,
          "page-sizes": [20, 50, 100],
          "page-size": _vm.pageSize,
          "current-page": _vm.page,
        },
        on: {
          "size-change": _vm.onSizeChange,
          "current-change": _vm.onPageChange,
        },
      }),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.detailTitle || _vm.$t("diagnostics.snapshotDetails"),
            visible: _vm.detailVisible,
            size: "640px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailVisible = $event
            },
          },
        },
        [
          _vm.detail
            ? _c(
                "div",
                { staticStyle: { padding: "0 20px 20px" } },
                [
                  _c(
                    "el-descriptions",
                    {
                      staticStyle: { "margin-bottom": "14px" },
                      attrs: {
                        title: _vm.$t("diagnostics.identity"),
                        column: 2,
                        border: "",
                        size: "small",
                      },
                    },
                    [
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("diagnostics.serialNo") } },
                        [_vm._v(_vm._s(_vm.detail.caneSerialNumber))]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "BLE MAC" } },
                        [_vm._v(_vm._s(_vm.detail.caneBleMac || "-"))]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("diagnostics.source") } },
                        [_vm._v(_vm._s(_vm.detail.source))]
                      ),
                      _c(
                        "el-descriptions-item",
                        {
                          attrs: {
                            label: _vm.$t("diagnostics.registeredDevice"),
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.detail.deviceId ||
                                _vm.$t("diagnostics.notRegistered")
                            )
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("diagnostics.user") } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.detail.userEmail || _vm.detail.userId || "-"
                            )
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "Firmware" } },
                        [_vm._v(_vm._s(_vm.detail.firmwareVersion || "-"))]
                      ),
                      _c("el-descriptions-item", { attrs: { label: "App" } }, [
                        _vm._v(
                          _vm._s(_vm.detail.appPlatform || "-") +
                            " " +
                            _vm._s(_vm.detail.appVersion || "")
                        ),
                      ]),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("diagnostics.received") } },
                        [_vm._v(_vm._s(_vm.fmtTime(_vm.detail.receivedAt)))]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: _vm.$t("diagnostics.deviceTime") } },
                        [
                          _vm._v(
                            _vm._s(_vm.fmtTime(_vm.detail.clientCapturedAt))
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm.s().battery
                    ? _c(
                        "el-descriptions",
                        {
                          staticStyle: { "margin-bottom": "14px" },
                          attrs: {
                            title: _vm.$t("diagnostics.battery"),
                            column: 2,
                            border: "",
                            size: "small",
                          },
                        },
                        [
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: _vm.$t("diagnostics.charge") } },
                            [_vm._v(_vm._s(_vm.s().battery.charge) + "%")]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: _vm.$t("diagnostics.health") } },
                            [
                              _vm._v(
                                _vm._s(_vm.s().battery.healthPercent) + "%"
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: _vm.$t("diagnostics.voltage") } },
                            [_vm._v(_vm._s(_vm.s().battery.voltageMv) + " mV")]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: _vm.$t("diagnostics.current") } },
                            [_vm._v(_vm._s(_vm.s().battery.currentMa) + " mA")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.s().faults
                    ? _c(
                        "el-descriptions",
                        {
                          staticStyle: { "margin-bottom": "14px" },
                          attrs: {
                            title: _vm.$t("diagnostics.faultRegisters"),
                            column: 2,
                            border: "",
                            size: "small",
                          },
                        },
                        _vm._l(_vm.s().faults, function (v, k) {
                          return _c(
                            "el-descriptions-item",
                            { key: k, attrs: { label: k } },
                            [
                              _c(
                                "span",
                                {
                                  style: {
                                    color: _vm.isFault(v)
                                      ? "#f56c6c"
                                      : "#67c23a",
                                    fontWeight: _vm.isFault(v) ? 700 : 400,
                                  },
                                },
                                [_vm._v(_vm._s(v))]
                              ),
                            ]
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm.s().obstacleDetection
                    ? _c(
                        "el-descriptions",
                        {
                          staticStyle: { "margin-bottom": "14px" },
                          attrs: {
                            title: _vm.$t("diagnostics.obstacleDetection"),
                            column: 2,
                            border: "",
                            size: "small",
                          },
                        },
                        _vm._l(_vm.s().obstacleDetection, function (v, k) {
                          return _c(
                            "el-descriptions-item",
                            { key: k, attrs: { label: k } },
                            [_vm._v(_vm._s(v))]
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm.s().ultrasonic
                    ? _c(
                        "el-descriptions",
                        {
                          staticStyle: { "margin-bottom": "14px" },
                          attrs: {
                            title: _vm.$t("diagnostics.ultrasonic"),
                            column: 2,
                            border: "",
                            size: "small",
                          },
                        },
                        _vm._l(_vm.s().ultrasonic, function (v, k) {
                          return _c(
                            "el-descriptions-item",
                            { key: k, attrs: { label: k } },
                            [_vm._v(_vm._s(v))]
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm.s().firmware
                    ? _c(
                        "el-descriptions",
                        {
                          staticStyle: { "margin-bottom": "14px" },
                          attrs: {
                            title: _vm.$t("diagnostics.firmwareSystem"),
                            column: 2,
                            border: "",
                            size: "small",
                          },
                        },
                        _vm._l(_vm.s().firmware, function (v, k) {
                          return _c(
                            "el-descriptions-item",
                            { key: k, attrs: { label: k } },
                            [_vm._v(_vm._s(v))]
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm.s().audio
                    ? _c(
                        "el-descriptions",
                        {
                          staticStyle: { "margin-bottom": "14px" },
                          attrs: {
                            title: _vm.$t("diagnostics.audio"),
                            column: 2,
                            border: "",
                            size: "small",
                          },
                        },
                        _vm._l(_vm.s().audio, function (v, k) {
                          return _c(
                            "el-descriptions-item",
                            { key: k, attrs: { label: k } },
                            [_vm._v(_vm._s(v))]
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm.detail.rawPayloadHex
                    ? _c(
                        "div",
                        { staticStyle: { "margin-top": "10px" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "13px",
                                color: "#909399",
                                "margin-bottom": "4px",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("diagnostics.rawPayload")))]
                          ),
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 3,
                              value: _vm.detail.rawPayloadHex,
                              readonly: "",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }